export const Board = {
  Type: {
    generalBoard: 1,
    classBoard: 2,
    gradeBoard: 3,
    brandBoard: 4,
  },
};
